import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Account } from '../../../models/AccountModel';
import { PlatformApiService } from '../../../services/platform-api.service';
import { ChartQuarters } from 'src/app/services/platform-api-types';

@Component({
  selector: 'app-account-risk-by-quarter',
  templateUrl: './account-risk-by-quarter.component.html',
  styleUrls: ['./account-risk-by-quarter.component.scss']
})
export class AccountRiskByQuarterComponent implements OnInit {

  @ViewChild('myCanvas') canvas: ElementRef;
  @Input() parentAccount: Account
  histogram = [];

  constructor(private _platformApi: PlatformApiService) { }

  gradient = ['#5bba47', '#74c463', '#8ccf7e', '#addda3'];

  public lineChartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [{
        scaleLabel: {
          display: false,
          labelString: 'Score',
          fontColor: 'white'
        },
        gridLines: {
          display: true,
          drawTicks: false,
          color: 'white'
        },
        ticks: {
          display: true,
          fontColor: 'white'
        }
      }],
      yAxes: [{
        scaleLabel: {
          display: false,
          labelString: 'Companies',
          fontColor: 'white'
        },
        gridLines: {
          display: true,
          drawTicks: true,
          color: 'white'
        },
        ticks: {
          suggestedMax: 10,
          stepSize: 1,
          min: 0,
          display: true,
          fontColor: 'white'
        }
      }]
    },
  };
  public lineChartLabels: string[] = ['Q3 2017', 'Q4 2017', 'Q1 2018', 'Q2 2018'];
  public lineChartStatusLabels: string[] = ['Low Risk', 'Medium Risk', 'High Risk', 'Critical Risk'];
  public lineChartType = 'line';
  public lineChartLegend = false;
  public lineChartColors: Array<any>;

  public lineChartData: any[] = [
    { data: [], label: 'Low Risk', lineTension: 0.1, fill: false },
    { data: [], label: 'Medium Risk', lineTension: 0.1, fill: false },
    { data: [], label: 'High Risk', lineTension: 0.1, fill: false },
    { data: [], label: 'Critical Risk', lineTension: 0.1, fill: false }
  ];
  private _lineChartData: any[] = [
    { data: [], label: 'Low Risk', lineTension: 0.1, fill: false },
    { data: [], label: 'Medium Risk', lineTension: 0.1, fill: false },
    { data: [], label: 'High Risk', lineTension: 0.1, fill: false },
    { data: [], label: 'Critical Risk', lineTension: 0.1, fill: false }
  ];

  ngOnInit() {
    this.lineChartLabels = new ChartQuarters(new Date(), 4).quarters.reverse();

    for (let i = 0; i < 4; i++) {
      this._lineChartData[0].data[i] = 0;
      this._lineChartData[1].data[i] = 0;
      this._lineChartData[2].data[i] = 0;
      this._lineChartData[3].data[i] = 0;
    }
    this.lineChartColors = [{
      backgroundColor: this.gradient[0],
      borderColor: this.gradient[0],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
    }, {
      backgroundColor: this.gradient[1],
      borderColor: this.gradient[1],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
    }, {
      backgroundColor: this.gradient[2],
      borderColor: this.gradient[2],
      hoverBorderColor: '#1a3047',
      hoverBorderWidth: 1
    }];
    this._platformApi.getAccountRiskChartData(this.parentAccount.id).subscribe(data => {
      let maxCount = 10;

      if (Array.isArray(data)) {
        data.forEach(row => {
          const statusInx = this.lineChartStatusLabels.indexOf(row.status);
          const qtrInx = this.lineChartLabels.indexOf(row.qtrYear);
          this._lineChartData[statusInx].data[qtrInx] += row.total;

          maxCount = Math.max(maxCount, this._lineChartData[statusInx].data[qtrInx]);
        });
      }

      if (maxCount <= 10) {
        this.lineChartOptions.scales.yAxes[0].ticks.max = 10;
        this.lineChartOptions.scales.yAxes[0].ticks.stepSize = 1;
      } else if (maxCount < 100) {
        this.lineChartOptions.scales.yAxes[0].ticks.max = 100;
        this.lineChartOptions.scales.yAxes[0].ticks.stepSize = 10;
      } else if (maxCount < 1000) {
        this.lineChartOptions.scales.yAxes[0].ticks.max = 1000;
        this.lineChartOptions.scales.yAxes[0].ticks.stepSize = 100;
      } else if (maxCount < 10000) {
        this.lineChartOptions.scales.yAxes[0].ticks.max = 10000;
        this.lineChartOptions.scales.yAxes[0].ticks.stepSize = 1000;
      } else {
        this.lineChartOptions.scales.yAxes[0].ticks.suggestedMax = 100000;
        this.lineChartOptions.scales.yAxes[0].ticks.stepSize = 100000;
      }

      this.lineChartData = this._lineChartData;
    });
  }
}
